export function stripHTML(text = '') {
  return String(text).replace(/<[^>]*>?/gm, '');
}
